import { connect } from 'react-redux';
import { BookVoiceSettings } from '../components/BookVoiceSettings';
import { IBookVoiceSettingsEvents, IBookVoiceSettingsOwnProps } from '../components/types';
import { BookVoiceSettingsEvents } from './events';

const mapDispatchToProps = (dispatch: any): IBookVoiceSettingsEvents => ({
	onLoadVoices: () => dispatch(BookVoiceSettingsEvents.onLoadVoices()),
	onGetSample: (languageName, voiceName) => dispatch(BookVoiceSettingsEvents.onGetSample(languageName, voiceName)),
	onSetVoice: (languageCode, voiceName) => dispatch(BookVoiceSettingsEvents.onSetVoice(languageCode, voiceName)),
});

export const BookVoiceSettingsHOC = connect<{}, IBookVoiceSettingsEvents, IBookVoiceSettingsOwnProps>(
	null,
	mapDispatchToProps
)(BookVoiceSettings);

BookVoiceSettingsHOC.displayName = 'BookVoiceSettingsHOC';
